/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

$(document).on("keydown", "form.Cart input", function(event) {
    if (event.which === 13) {
        event.preventDefault();
        return false;
    }
});

(()=>{
    /**
     * SPサイズの際にImage--lazyLoadが付与されない問題
     *
     */
    const boxes = document.querySelectorAll(".Image--lazyLoad");

    const options = {
    root: null,
    rootMargin: "-25% 0px",
    threshold: 0
    };
    const observer = new IntersectionObserver(doWhenIntersect, options);

    boxes.forEach(box => {
        if(window.innerWidth < 768){
            observer.observe(box);
        }
    });

    /**
     * 交差したときに呼び出す関数
     * @param entries
     */
    function doWhenIntersect(entries) {
    // 交差検知をしたもののなかで、isIntersectingがtrueのDOMを色を変える関数に渡す
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                activateIndex(entry.target);
            }
        });
    }

    /**
     *  Image--lazyLoadedを追加
     * @param {*} element
     */
    function activateIndex(element) {
        element.classList.add("Image--lazyLoaded");
    }

})();

/**
 * sample Voice accordion
 *
 */
$(function(){
    if($('.SampleVoice__Wrapper').length == 0) return;

    const threshold_num = 5;
    const close_text = (location.href.indexOf('/zh') != -1) ? '隐藏' : 'close';
    const more_text = (location.href.indexOf('/zh') != -1) ? '试听' : 'more';

    if($('.SampleVoice__Wrapper').children().length > threshold_num){
        $('.SampleVoice__Inner').hide();
    }

    $('.js-morebtn').on('click', function() {
        $('.SampleVoice__Inner').slideToggle();
        $(this).toggleClass('is-active');

        if($(this).attr('aria-expanded') == 'false'){
            $(this).attr('aria-expanded', true);
            $(this).find('.text').text(close_text);
        }else{
            $(this).attr('aria-expanded', false);
            $(this).find('.text').text(more_text);
        }
    });
});


/**
 * Collection page Accordion
 *
 */
$(function(){
    if(window.innerWidth <= 750 && $('.toggle_Collection_profile').length > 0) {

        $('.Collection__socialLinkListWrapper').hide();
        $('.Collection__profileInner p').hide();
        $('.Collection__profileInner p').eq(0).show();
    }

    $('.toggle_Collection_profile').on('click',function(){
        $(this).toggleClass('is-active');
        $('.Collection__profileInner').toggleClass('is-open');
        $('.Collection__profileInner p').each(function(index){
            if(index == 0) return;
            $(this).slideToggle();
        });
        $('.Collection__socialLinkListWrapper').slideToggle();
    })

});

let windowWidth = window.innerWidth;

console.log(windowWidth);

$(window).on('resize',function(){

    if(window.innerWidth == windowWidth) return;
    if($('.Collection__profileInner p').length == 0) return;

    windowWidth = window.innerWidth;

    if(window.innerWidth > 750){
      console.log("こんにちは")
        $('.Collection__socialLinkListWrapper').show();
        $('.Collection__profileInner p').show();
        $('.Collection__profileInner').removeClass('is-open');
        $('.toggle_Collection_profile').removeClass('is-active');

    }else{
        if(!$('.toggle_Collection_profile').hasClass('is-active')){
            $('.Collection__socialLinkListWrapper').hide();
            $('.Collection__profileInner p').hide();
            $('.Collection__profileInner p').eq(0).show();
            $('.toggle_Collection_profile').removeClass('is-active');
        }
    }
});


  // GLOBAL-E セレクター
    $('.shopify-localization-form select').on('change', function() {
    document.cookie = 'locale_popup=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT';
    $(this).closest('form').submit();
})

$(function() {
    if($('.countryPopup').length == 0) return;
    const localization = getLocalizationCookie();
    if(document.cookie.indexOf('locale_popup') != -1){
        $('.countryPopup').hide();
        return;
    }
    if(countryArray.includes(localization)){
        $('.countryPopup').show();
        document.cookie = 'locale_popup=true; path=/';
    }
    $('.js-closePopup').on('click', function() {
        $('.countryPopup').hide();
    });

    $('body').on('click', function(event) {
        if (!$(event.target).closest('.countryPopup').length) {
            $('.countryPopup').hide();
        }
    });

    function getCookie(name) {
        const value = `;${document.cookie}`;
        const parts = value.split(`; ${name}=`);
        if (parts.length === 2) return parts.pop().split(';').shift();
    }

    function getCookieByPath(name, path = '/') {
    const cookies = document.cookie.split(';').map(cookie => cookie.trim());

    for (const cookie of cookies) {
      const [key, value] = cookie.split('=');
      if (key === name && document.location.pathname.startsWith(path)) {
        return decodeURIComponent(value);
      }
    }
    return null;
  }

function getLocalizationCookie() {
    const url = window.location.href;
    const containsZh = url.includes('/zh/');
    const localization = containsZh ? getCookieByPath('localization', '/zh') : getCookieByPath('localization');
  return localization;
}
});


$(window).on('scroll', function() {
  if ($(this).scrollTop() > 0) {
    $('body').addClass('is-scrolled');
  } else {
    $('body').removeClass('is-scrolled');
  }
});

/**
 * 利用規定承認機能
 * REQUIRES_TERMS_APPROVALタグが付いている商品は、購入前に利用規定への承認が必要
 */
(function() {
  'use strict';

  // モーダルのキャンセル/閉じるボタンのグローバルイベントリスナー（確実に動作させるため）
  // 最高優先度で実行されるように、即座に登録（他のスクリプトより先に実行されるように）
  // 複数のイベントリスナーを登録して、確実に動作させる
  (function() {
    function handleModalClose(e) {
      // モーダル内の要素かどうかを確認
      const modal = document.getElementById('terms-approval-modal');
      if (!modal) return;
      
      // クリックされた要素がモーダル内にあるか確認
      if (!modal.contains(e.target)) return;
      
      // ターゲット要素を確認
      const target = e.target.closest('[data-action="close-terms-modal"], .TermsApprovalModal__Close, .TermsApprovalModal__CancelButton');
      if (!target) return;
      
      // モーダルの表示状態を正確にチェック
      const computedStyle = window.getComputedStyle(modal);
      const isDisplayNone = computedStyle.display === 'none' || modal.style.display === 'none';
      const isAriaHidden = modal.getAttribute('aria-hidden') === 'true';
      
      if (isDisplayNone || isAriaHidden) return;

      console.log('グローバルイベントリスナーでキャンセルボタンがクリックされました:', target);
      
      // 他のイベントリスナーの実行を止める（最高優先度）
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      
      // モーダルを直接閉じる
      modal.style.display = 'none';
      modal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      console.log('モーダルを閉じました');
      
      return false;
    }
    
    // 即座に登録（他のスクリプトより先に実行されるように）
    // useCaptureをtrueにして、capture phaseで実行（最高優先度）
    // 複数回登録して、確実に動作させる
    document.addEventListener('click', handleModalClose, { capture: true, passive: false });
    
    // さらに早いタイミングで登録（スクリプトの読み込み順序に関係なく）
    if (document.readyState === 'loading') {
      // スクリプトが読み込まれる前に登録
      const script = document.currentScript || document.scripts[document.scripts.length - 1];
      if (script) {
        script.addEventListener('load', function() {
          document.addEventListener('click', handleModalClose, { capture: true, passive: false });
        });
      }
    }
    
    // DOMContentLoaded時にも再登録（念のため）
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function() {
        document.addEventListener('click', handleModalClose, { capture: true, passive: false });
      });
    } else {
      // 既にDOMが読み込まれている場合は即座に再登録
      setTimeout(function() {
        document.addEventListener('click', handleModalClose, { capture: true, passive: false });
      }, 0);
    }
    
    // window.onload時にも再登録（さらに念のため）
    window.addEventListener('load', function() {
      document.addEventListener('click', handleModalClose, { capture: true, passive: false });
    });
  })();

  // セッションストレージから承認状態を取得
  function getApprovedProducts() {
    try {
      const approved = sessionStorage.getItem('termsApprovedProducts');
      return approved ? JSON.parse(approved) : [];
    } catch (e) {
      return [];
    }
  }

  // セッションストレージに承認状態を保存
  function setApprovedProduct(productId) {
    try {
      const approved = getApprovedProducts();
      if (!approved.includes(productId)) {
        approved.push(productId);
        sessionStorage.setItem('termsApprovedProducts', JSON.stringify(approved));
      }
    } catch (e) {
      console.error('Failed to save approval status:', e);
    }
  }

  // 商品が承認済みかチェック
  function isProductApproved(productId) {
    const approved = getApprovedProducts();
    return approved.includes(productId);
  }

  // 商品が承認を必要とするかチェック
  function requiresApproval(productId) {
    const input = document.getElementById('product-requires-terms-approval');
    if (!input) return false;
    return input.getAttribute('data-product-id') === String(productId) && input.value === 'true';
  }

  // ポップアップを表示
  function showTermsModal(productId, callback) {
    console.log('showTermsModalが呼ばれました。商品ID:', productId);
    let modal = document.getElementById('terms-approval-modal');
    if (!modal) {
      console.error('ポップアップ要素が見つかりません');
      // モーダルが存在しない場合はそのまま実行
      if (callback) callback();
      return;
    }

    // 既存のイベントリスナーをクリーンアップ（重複を防ぐ）
    const approveButton = modal.querySelector('[data-action="approve-terms"]');
    const cancelButton = modal.querySelector('[data-action="close-terms-modal"]');
    const closeButton = modal.querySelector('.TermsApprovalModal__Close');
    const overlay = modal.querySelector('.TermsApprovalModal__Overlay');
    const checkbox = document.getElementById('terms-approval-checkbox');

    if (approveButton && approveButton._approveHandler) {
      approveButton.removeEventListener('click', approveButton._approveHandler);
      delete approveButton._approveHandler;
    }
    if (cancelButton && cancelButton._closeHandler) {
      cancelButton.removeEventListener('click', cancelButton._closeHandler);
      delete cancelButton._closeHandler;
    }
    if (closeButton && closeButton._closeHandler) {
      closeButton.removeEventListener('click', closeButton._closeHandler);
      delete closeButton._closeHandler;
    }
    if (overlay && overlay._closeHandler) {
      overlay.removeEventListener('click', overlay._closeHandler);
      delete overlay._closeHandler;
    }
    if (checkbox) {
      checkbox.removeEventListener('change', checkbox._updateApproveButton);
      delete checkbox._updateApproveButton;
    }

    // モーダルをbodyの直接の子要素として移動（スタックコンテキストの問題を回避）
    if (modal.parentElement !== document.body) {
      document.body.appendChild(modal);
    }

    console.log('ポップアップを表示します');
    
    // モーダルを表示する前に、すべての非表示状態をリセット
    // 1. is-hiddenクラスを削除
    modal.classList.remove('is-hidden');
    
    // 2. aria-hidden属性をfalseに設定
    modal.setAttribute('aria-hidden', 'false');
    
    // 3. すべての非表示スタイルをリセット
    modal.style.removeProperty('display');
    modal.style.removeProperty('visibility');
    modal.style.removeProperty('opacity');
    modal.style.removeProperty('pointer-events');
    
    // 4. 表示スタイルを設定
    modal.style.setProperty('display', 'flex', 'important');
    modal.style.setProperty('visibility', 'visible', 'important');
    modal.style.setProperty('opacity', '1', 'important');
    modal.style.setProperty('pointer-events', 'auto', 'important');
    modal.style.zIndex = '99999';
    
    // 5. bodyのoverflowを設定
    document.body.style.overflow = 'hidden';
    
    console.log('モーダルを表示しました。display:', window.getComputedStyle(modal).display);

    // チェックボックスの状態に応じて承認ボタンを有効/無効化
    function updateApproveButton() {
      if (checkbox && approveButton) {
        approveButton.disabled = !checkbox.checked;
      }
    }

    if (checkbox) {
      checkbox.checked = false;
      checkbox.addEventListener('change', updateApproveButton);
      checkbox._updateApproveButton = updateApproveButton;
      updateApproveButton();
    }

    // 承認ボタンのクリック処理
    if (approveButton) {
      const approveHandler = function(e) {
        console.log('承認ボタンがクリックされました');
        if (e) {
          e.preventDefault();
          e.stopPropagation();
        }
        
        if (checkbox && checkbox.checked) {
          console.log('チェックボックスがチェックされています。承認処理を実行します。');
          setApprovedProduct(productId);
          closeTermsModal();
          
          // callbackを実行する前に少し遅延（モーダルが閉じるのを待つ）
          setTimeout(function() {
            console.log('callbackを実行します:', callback);
            if (callback) {
              callback();
            } else {
              console.warn('callbackが定義されていません');
            }
          }, 100);
        } else {
          console.log('チェックボックスがチェックされていません');
        }
      };
      
      // 既存のイベントリスナーを削除
      if (approveButton._approveHandler) {
        approveButton.removeEventListener('click', approveButton._approveHandler);
      }
      
      // 複数の方法でイベントリスナーを設定
      approveButton.onclick = approveHandler;
      approveButton.addEventListener('click', approveHandler, true); // capture phaseで登録
      
      // 一度だけ実行されるようにするため、イベントリスナーを削除できるようにする
      approveButton._approveHandler = approveHandler;
      
      console.log('承認ボタンのイベントリスナーを設定しました');
    } else {
      console.error('承認ボタンが見つかりません');
    }

    // キャンセル/閉じるボタンのクリック処理
    // 確実に動作させるため、複数の方法でイベントリスナーを設定
    function setupCloseHandlers() {
      // キャンセルボタン
      const allCancelButtons = modal.querySelectorAll('[data-action="close-terms-modal"]');
      allCancelButtons.forEach(function(btn) {
        // 既存のイベントリスナーを削除
        btn.onclick = null;
        // 新しいイベントリスナーを設定（複数の方法で）
        btn.onclick = function(e) {
          console.log('キャンセルボタンがクリックされました（onclick）');
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          closeTermsModal();
          return false;
        };
        // addEventListenerも設定（capture phaseで）
        btn.addEventListener('click', function(e) {
          console.log('キャンセルボタンがクリックされました（addEventListener）');
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          closeTermsModal();
        }, true);
      });

      // 閉じるボタン（×ボタン）
      const allCloseButtons = modal.querySelectorAll('.TermsApprovalModal__Close');
      allCloseButtons.forEach(function(btn) {
        btn.onclick = function(e) {
          console.log('閉じるボタンがクリックされました');
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          closeTermsModal();
          return false;
        };
        btn.addEventListener('click', function(e) {
          console.log('閉じるボタンがクリックされました（addEventListener）');
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          closeTermsModal();
        }, true);
      });

      // オーバーレイクリックで閉じる
      if (overlay) {
        overlay.onclick = function(e) {
          if (e.target === overlay) {
            console.log('オーバーレイがクリックされました');
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
            closeTermsModal();
            return false;
          }
        };
        overlay.addEventListener('click', function(e) {
          if (e.target === overlay) {
            console.log('オーバーレイがクリックされました（addEventListener）');
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
            closeTermsModal();
          }
        }, true);
      }
    }

    // イベントリスナーを設定
    setupCloseHandlers();
    
    // 少し遅延して再設定（他のスクリプトが実行された後）
    setTimeout(function() {
      setupCloseHandlers();
    }, 100);
  }

  // ポップアップを閉じる
  function closeTermsModal() {
    console.log('closeTermsModalが呼ばれました');
    
    // すべてのモーダル要素を取得（複数存在する可能性がある）
    const modals = document.querySelectorAll('#terms-approval-modal');
    console.log('見つかったモーダルの数:', modals.length);
    
    if (modals.length === 0) {
      console.error('モーダルが見つかりません');
      return;
    }

    // すべてのモーダルを閉じる
    modals.forEach(function(modal, index) {
      console.log('モーダル', index + 1, 'を閉じます');
      
      // 複数の方法で確実に非表示にする
      // 1. is-hiddenクラスを追加
      modal.classList.add('is-hidden');
      
      // 2. aria-hidden属性を設定
      modal.setAttribute('aria-hidden', 'true');
      
      // 3. インラインスタイルでdisplay: noneを設定（!important付き）
      modal.style.setProperty('display', 'none', 'important');
      
      // 4. 念のため、visibilityも設定
      modal.style.setProperty('visibility', 'hidden', 'important');
      modal.style.setProperty('opacity', '0', 'important');
      modal.style.setProperty('pointer-events', 'none', 'important');
      
      // 5. モーダルをDOMから削除する（最後の手段）
      setTimeout(function() {
        const computedStyle = window.getComputedStyle(modal);
        console.log('モーダル', index + 1, 'の状態 - display:', computedStyle.display, 'visibility:', computedStyle.visibility);
        
        // まだ表示されている場合は、さらに強制的に非表示にする（DOMから削除しない）
        if (computedStyle.display !== 'none' || computedStyle.visibility !== 'hidden') {
          console.warn('モーダル', index + 1, 'がまだ表示されています。強制的に非表示にします。');
          modal.style.setProperty('display', 'none', 'important');
          modal.style.setProperty('visibility', 'hidden', 'important');
          modal.style.setProperty('opacity', '0', 'important');
          modal.style.setProperty('pointer-events', 'none', 'important');
        }
      }, 10);
    });
    
    // bodyのoverflowをリセット
    document.body.style.overflow = '';
    
    console.log('すべてのモーダルを閉じました');

    // イベントリスナーをクリーンアップ（すべてのモーダルに対して）
    modals.forEach(function(modal) {
      const approveButton = modal.querySelector('[data-action="approve-terms"]');
      const cancelButton = modal.querySelector('[data-action="close-terms-modal"]');
      const closeButton = modal.querySelector('.TermsApprovalModal__Close');
      const overlay = modal.querySelector('.TermsApprovalModal__Overlay');

      if (approveButton && approveButton._approveHandler) {
        approveButton.removeEventListener('click', approveButton._approveHandler);
        delete approveButton._approveHandler;
      }
      if (cancelButton && cancelButton._closeHandler) {
        cancelButton.removeEventListener('click', cancelButton._closeHandler);
        delete cancelButton._closeHandler;
      }
      if (closeButton && closeButton._closeHandler) {
        closeButton.removeEventListener('click', closeButton._closeHandler);
        delete closeButton._closeHandler;
      }
      if (overlay && overlay._closeHandler) {
        overlay.removeEventListener('click', overlay._closeHandler);
        delete overlay._closeHandler;
      }
    });
    
    // チェックボックスは1つだけなので、一度だけリセット
    const checkbox = document.getElementById('terms-approval-checkbox');
    if (checkbox) {
      checkbox.checked = false;
    }
  }

  // toggle-cart-noteボタンのクリックをインターセプト
  // ポップアップを表示して同意後にカートノートの切り替えを実行
  document.addEventListener('click', function(e) {
    const toggleCartNoteTarget = e.target.closest('[data-action="toggle-cart-note"]');
    if (toggleCartNoteTarget) {
      // カートノートの切り替えを一旦止める
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      console.log('toggle-cart-noteがクリックされました', toggleCartNoteTarget);

      // 商品IDを取得（カート内の商品から取得を試みる）
      let productId = null;
      const cartElement = document.getElementById('sidebar-cart');
      if (cartElement) {
        const requiresApprovalIds = cartElement.getAttribute('data-requires-approval-product-ids');
        if (requiresApprovalIds && requiresApprovalIds.trim() !== '') {
          const productIds = requiresApprovalIds.split(',').filter(id => id.trim() !== '');
          if (productIds.length > 0) {
            productId = productIds[0].trim();
          }
        }
      }

      // 商品IDが取得できない場合はデフォルト値を使用
      if (!productId) {
        productId = 'cart-note-' + Date.now();
      }

      console.log('ポップアップを表示します。商品ID:', productId);

      // モーダルを探す（カートドロワー内、body内、どこでも）
      let modal = document.getElementById('terms-approval-modal');
      
      // モーダルが見つからない場合は、body内を再検索
      if (!modal) {
        console.log('モーダルが見つかりません。body内を再検索します...');
        modal = document.body.querySelector('#terms-approval-modal');
      }
      
      // まだ見つからない場合は、document全体を検索
      if (!modal) {
        console.log('モーダルが見つかりません。document全体を検索します...');
        modal = document.querySelector('#terms-approval-modal');
      }

      if (!modal) {
        console.error('ポップアップ要素が見つかりません。通常の処理を続行します。');
        console.log('現在のDOM構造:', document.body.innerHTML.substring(0, 500));
        // ポップアップがない場合は通常の処理を続行
        executeToggleCartNote(toggleCartNoteTarget);
        return;
      }

      console.log('モーダル要素を確認しました:', modal);

      showTermsModal(productId, function() {
        // 承認後にカートノートの切り替えを実行
        console.log('承認が完了しました。カートノートを切り替えます。');
        executeToggleCartNote(toggleCartNoteTarget);
      });
      return;
    }
  }, true); // captureフェーズでイベントをキャッチ

  // カートノートの切り替えを実行する関数
  function executeToggleCartNote(button) {
    const cartDrawer = document.getElementById('sidebar-cart');
    if (!cartDrawer) {
      console.error('カートドロワーが見つかりません');
      return;
    }

    const noteContainer = cartDrawer.querySelector('.Cart__OffscreenNoteContainer');
    const cartNote = cartDrawer.querySelector('#cart-note');
    const noteButton = cartDrawer.querySelector('.Cart__NoteButton');

    if (noteContainer && cartNote) {
      // theme.jsの_toggleCartNoteメソッドと同じ処理を実行
      cartDrawer.classList.toggle('has-note-open');
      
      if (noteButton) {
        const isNoteOpen = cartDrawer.classList.contains('has-note-open');
        if (isNoteOpen) {
          // ノートが開いた状態
          noteButton.innerHTML = cartNote.value !== '' ? 
            (window.languages && window.languages.cartEditNote ? window.languages.cartEditNote : '編集') : 
            (window.languages && window.languages.cartAddNote ? window.languages.cartAddNote : '追加');
        } else {
          // ノートが閉じた状態
          noteButton.innerHTML = cartNote.value !== '' ? 
            (window.languages && window.languages.cartEditNote ? window.languages.cartEditNote : '編集') : 
            (window.languages && window.languages.cartAddNote ? window.languages.cartAddNote : '追加');
        }
      }

      const isHidden = noteContainer.getAttribute('aria-hidden') === 'true';
      noteContainer.setAttribute('aria-hidden', isHidden ? 'false' : 'true');

      if (cartDrawer.classList.contains('has-note-open')) {
        // フォーカスを設定
        setTimeout(function() {
          if (cartNote) {
            cartNote.focus();
          }
        }, 100);
      }
    } else {
      console.error('カートノートの要素が見つかりません');
    }
  }

  // カートに承認情報を保存する関数
  function saveApprovalToCartAttribute() {
    const termsApproved = 'true';
    const termsApprovedAt = new Date().toISOString();
    
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        attributes: {
          'terms_approved': termsApproved,
          'terms_approved_at': termsApprovedAt
        }
      }),
      keepalive: true // ページ遷移後もリクエストを継続
    })
    .then(response => response.json())
    .then(data => {
      console.log('承認情報をカート属性に保存しました:', data);
      
      // フォームにもhidden inputを追加（確実に注文に反映されるように）
      addApprovalAttributesToForm(termsApproved, termsApprovedAt);
      
      return data;
    })
    .catch(error => {
      console.error('カート属性の保存に失敗しました:', error);
      throw error;
    });
  }

  // フォームに承認属性を追加する関数
  function addApprovalAttributesToForm(termsApproved, termsApprovedAt) {
    // カートドロワーのフォーム
    const cartDrawerForm = document.querySelector('#sidebar-cart form.Cart');
    if (cartDrawerForm) {
      // 既存のinputを削除（重複を防ぐ）
      const existingApproved = cartDrawerForm.querySelector('input[name="attributes[terms_approved]"]');
      const existingApprovedAt = cartDrawerForm.querySelector('input[name="attributes[terms_approved_at]"]');
      if (existingApproved) existingApproved.remove();
      if (existingApprovedAt) existingApprovedAt.remove();
      
      // 新しいinputを追加
      const approvedInput = document.createElement('input');
      approvedInput.type = 'hidden';
      approvedInput.name = 'attributes[terms_approved]';
      approvedInput.value = termsApproved;
      cartDrawerForm.appendChild(approvedInput);
      
      const approvedAtInput = document.createElement('input');
      approvedAtInput.type = 'hidden';
      approvedAtInput.name = 'attributes[terms_approved_at]';
      approvedAtInput.value = termsApprovedAt;
      cartDrawerForm.appendChild(approvedAtInput);
    }
    
    // カートページのフォーム
    const cartPageForm = document.querySelector('form.Cart--expanded');
    if (cartPageForm) {
      // 既存のinputを削除（重複を防ぐ）
      const existingApproved = cartPageForm.querySelector('input[name="attributes[terms_approved]"]');
      const existingApprovedAt = cartPageForm.querySelector('input[name="attributes[terms_approved_at]"]');
      if (existingApproved) existingApproved.remove();
      if (existingApprovedAt) existingApprovedAt.remove();
      
      // 新しいinputを追加
      const approvedInput = document.createElement('input');
      approvedInput.type = 'hidden';
      approvedInput.name = 'attributes[terms_approved]';
      approvedInput.value = termsApproved;
      cartPageForm.appendChild(approvedInput);
      
      const approvedAtInput = document.createElement('input');
      approvedAtInput.type = 'hidden';
      approvedAtInput.name = 'attributes[terms_approved_at]';
      approvedAtInput.value = termsApprovedAt;
      cartPageForm.appendChild(approvedAtInput);
    }
  }

  // カート内に承認が必要な商品があるかチェックする関数
  // サブスクリプション商品がある場合、毎回ポップアップを表示する
  function checkCartRequiresApproval() {
    // まず、cart-drawer.liquidで設定された属性を確認
    let cartElement = document.getElementById('sidebar-cart');
    if (!cartElement) {
      cartElement = document.querySelector('[data-section-type="cart"]');
    }

    // カートAPIから商品情報を取得
    return fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        if (!cart || !cart.items || cart.items.length === 0) {
          return { requiresApproval: false, productIds: [], hasSubscription: false };
        }

        const requiresApprovalProductIds = [];
        let hasSubscription = false;

        // サブスクリプション商品があるかチェック
        for (let i = 0; i < cart.items.length; i++) {
          const item = cart.items[i];
          // サブスクリプション商品かどうかを判定（selling_planが存在する場合）
          // selling_planは数値、文字列、またはオブジェクトの可能性がある
          if (item.selling_plan !== null && item.selling_plan !== undefined && item.selling_plan !== '') {
            // オブジェクトの場合はidプロパティを確認
            if (typeof item.selling_plan === 'object' && item.selling_plan.id) {
              hasSubscription = true;
              requiresApprovalProductIds.push(String(item.product_id));
            } else if (typeof item.selling_plan === 'number' || typeof item.selling_plan === 'string') {
              // 数値または文字列の場合はそのまま使用
              hasSubscription = true;
              requiresApprovalProductIds.push(String(item.product_id));
            }
          }
        }

        // サブスクリプション商品がない場合、REQUIRES_TERMS_APPROVAL はサーバー描画の属性で判定
        // ※AJAXでカート追加した直後は #sidebar-cart の data 属性が更新されないため、
        //   チェックアウト時に /cart?view=drawer を取得して最新の承認対象IDを使う
        if (!hasSubscription) {
          function parseIdsFromDom(el) {
            if (!el) return;
            const requiresApprovalIds = el.getAttribute('data-requires-approval-product-ids');
            if (requiresApprovalIds && requiresApprovalIds.trim() !== '') {
              requiresApprovalIds.split(',').filter(id => id.trim() !== '').forEach(id => {
                const trimmed = id.trim();
                if (!requiresApprovalProductIds.includes(trimmed)) {
                  requiresApprovalProductIds.push(trimmed);
                }
              });
            }
          }

          // まず最新のドロワーHTMLを取得して判定（ポップアップが出ない不具合を防ぐ）
          return fetch(window.routes && window.routes.cartUrl ? window.routes.cartUrl + '?view=drawer&timestamp=' + Date.now() : '/cart?view=drawer&timestamp=' + Date.now(), {
            credentials: 'same-origin',
            method: 'GET'
          })
            .then(function(res) { return res.text(); })
            .then(function(html) {
              const parser = new DOMParser();
              const doc = parser.parseFromString(html, 'text/html');
              const freshDrawer = doc.getElementById('sidebar-cart');
              if (freshDrawer) {
                parseIdsFromDom(freshDrawer);
              }
              if (requiresApprovalProductIds.length > 0) {
                return {
                  requiresApproval: true,
                  productIds: requiresApprovalProductIds,
                  hasSubscription: hasSubscription
                };
              }
              // 取得HTMLに属性が無い場合は現在のDOMをフォールバック
              parseIdsFromDom(cartElement);
              const cartSection = document.querySelector('[data-section-type="cart"]');
              if (cartSection && cartSection !== cartElement) {
                parseIdsFromDom(cartSection);
              }
              return {
                requiresApproval: requiresApprovalProductIds.length > 0,
                productIds: requiresApprovalProductIds,
                hasSubscription: hasSubscription
              };
            })
            .catch(function() {
              // 取得失敗時は現在のDOMの属性を使用
              parseIdsFromDom(cartElement);
              const cartSection = document.querySelector('[data-section-type="cart"]');
              if (cartSection && cartSection !== cartElement) {
                parseIdsFromDom(cartSection);
              }
              return {
                requiresApproval: requiresApprovalProductIds.length > 0,
                productIds: requiresApprovalProductIds,
                hasSubscription: hasSubscription
              };
            });
        }

        return {
          requiresApproval: requiresApprovalProductIds.length > 0,
          productIds: requiresApprovalProductIds,
          hasSubscription: hasSubscription
        };
      })
      .catch(error => {
        console.error('カート情報の取得に失敗しました:', error);
        // エラー時は、cart-drawer.liquidで設定された属性を確認
        if (cartElement) {
          const requiresApprovalIds = cartElement.getAttribute('data-requires-approval-product-ids');
          if (requiresApprovalIds && requiresApprovalIds.trim() !== '') {
            const productIds = requiresApprovalIds.split(',').filter(id => id.trim() !== '');
            return {
              requiresApproval: productIds.length > 0,
              productIds: productIds,
              hasSubscription: false
            };
          }
        }
        // エラー時は安全のため、承認が必要とみなす
        return { requiresApproval: true, productIds: [], hasSubscription: false };
      });
  }

  // チェックアウトボタンのクリックをインターセプト
  // より早いタイミングでイベントをキャッチするため、captureフェーズで登録
  document.addEventListener('click', function(e) {
    const checkoutButton = e.target.closest('.Cart__Checkout, button[name="checkout"]');
    if (!checkoutButton) return;

    console.log('チェックアウトボタンがクリックされました', checkoutButton);

    // チェックアウトを一旦止める（承認チェック後に続行するか判断）
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    // カートAPIから直接商品情報を取得して承認が必要かチェック
    checkCartRequiresApproval()
      .then(result => {
        console.log('承認チェック結果:', result);

        // サブスクリプション商品がある場合、承認済みかどうかに関わらずポップアップを表示
        if (result.hasSubscription) {
          console.log('サブスクリプション商品があります。ポップアップを表示します。');
          
          // モーダルを確実に探す（複数の方法で検索）
          let modal = document.getElementById('terms-approval-modal');
          if (!modal) {
            // body内を検索
            modal = document.body.querySelector('#terms-approval-modal');
          }
          if (!modal) {
            // document全体を検索
            modal = document.querySelector('#terms-approval-modal');
          }
          if (!modal) {
            // カートドロワー内を検索
            const cartDrawer = document.getElementById('sidebar-cart');
            if (cartDrawer) {
              modal = cartDrawer.querySelector('#terms-approval-modal');
            }
          }
          if (!modal) {
            // カートページ内を検索
            const cartSection = document.querySelector('[data-section-type="cart"]');
            if (cartSection) {
              modal = cartSection.querySelector('#terms-approval-modal');
            }
          }

          if (!modal) {
            console.error('ポップアップ要素が見つかりません。チェックアウトを続行します。');
            // チェックアウト画面に遷移
            window.location.href = '/checkout';
            return;
          }

          console.log('モーダル要素を確認しました:', modal);

          // 商品IDを取得（最初の商品IDを使用）
          const productId = result.productIds.length > 0 ? result.productIds[0] : 'checkout-' + Date.now();

          showTermsModal(productId, function() {
            // 承認後にカート属性の保存を開始し、完了してからチェックアウト画面に遷移
            console.log('承認が完了しました。カート属性を保存してからチェックアウト画面に遷移します。');
            
            // カート属性の保存が完了してからチェックアウト画面に遷移
            saveApprovalToCartAttribute()
              .then(() => {
                console.log('承認情報をカート属性に保存しました。チェックアウト画面に遷移します。');
                // 保存が完了してから遷移
                window.location.href = '/checkout';
              })
              .catch(error => {
                console.error('カート属性の保存に失敗しました:', error);
                // エラー時もチェックアウト画面に遷移（フォームのhidden inputでフォールバック）
                window.location.href = '/checkout';
              });
          });
          return;
        }

        if (!result.requiresApproval) {
          // 承認が必要な商品がない場合はそのままチェックアウト画面に遷移
          console.log('承認が必要な商品がありません。チェックアウト画面に遷移します。');
          window.location.href = '/checkout';
          return;
        }

        // 承認が必要な商品がある場合はポップアップを表示
        console.log('承認が必要な商品があります。ポップアップを表示します。');

        // モーダルを確実に探す（複数の方法で検索）
        let modal = document.getElementById('terms-approval-modal');
        if (!modal) {
          // body内を検索
          modal = document.body.querySelector('#terms-approval-modal');
        }
        if (!modal) {
          // document全体を検索
          modal = document.querySelector('#terms-approval-modal');
        }
        if (!modal) {
          // カートドロワー内を検索
          const cartDrawer = document.getElementById('sidebar-cart');
          if (cartDrawer) {
            modal = cartDrawer.querySelector('#terms-approval-modal');
          }
        }
        if (!modal) {
          // カートページ内を検索
          const cartSection = document.querySelector('[data-section-type="cart"]');
          if (cartSection) {
            modal = cartSection.querySelector('#terms-approval-modal');
          }
        }

        if (!modal) {
          console.error('ポップアップ要素が見つかりません。チェックアウトを続行します。');
          // チェックアウト画面に遷移
          window.location.href = '/checkout';
          return;
        }

        console.log('モーダル要素を確認しました:', modal);

        // 商品IDを取得（最初の商品IDを使用）
        const productId = result.productIds.length > 0 ? result.productIds[0] : 'checkout-' + Date.now();

        showTermsModal(productId, function() {
          // 承認後にカート属性の保存を開始し、完了してからチェックアウト画面に遷移
          console.log('承認が完了しました。カート属性を保存してからチェックアウト画面に遷移します。');
          
          // カート属性の保存が完了してからチェックアウト画面に遷移
          saveApprovalToCartAttribute()
            .then(() => {
              console.log('承認情報をカート属性に保存しました。チェックアウト画面に遷移します。');
              // 保存が完了してから遷移
              window.location.href = '/checkout';
            })
            .catch(error => {
              console.error('カート属性の保存に失敗しました:', error);
              // エラー時もチェックアウト画面に遷移（フォームのhidden inputでフォールバック）
              window.location.href = '/checkout';
            });
        });
      })
      .catch(error => {
        console.error('承認チェック中にエラーが発生しました:', error);
        // エラー時は安全のため、ポップアップを表示
        const modal = document.getElementById('terms-approval-modal') || 
                      document.body.querySelector('#terms-approval-modal') ||
                      document.querySelector('#terms-approval-modal');
        
        if (modal) {
          showTermsModal('checkout-' + Date.now(), function() {
            // カート属性の保存が完了してからチェックアウト画面に遷移
            saveApprovalToCartAttribute()
              .then(() => {
                console.log('承認情報をカート属性に保存しました。チェックアウト画面に遷移します。');
                window.location.href = '/checkout';
              })
              .catch(err => {
                console.error('カート属性の保存に失敗しました:', err);
                // エラー時もチェックアウト画面に遷移（フォームのhidden inputでフォールバック）
                window.location.href = '/checkout';
              });
          });
        } else {
          // モーダルが見つからない場合はそのままチェックアウト画面に遷移
          window.location.href = '/checkout';
        }
      });
  }, true); // captureフェーズでイベントをキャッチ

  // 商品ページでの承認チェック（ページロード時）
  $(document).ready(function() {
    const input = document.getElementById('product-requires-terms-approval');
    if (input) {
      const productId = input.getAttribute('data-product-id');
      // 商品ページがロードされた時点で、承認が必要な商品であることを記録
      // 実際の承認チェックは、カート追加時に行う
    }
  });
})();
